
// src/actions/product-tour.native.js

import PermanentStore from './permanent-store'

const KEY = "gambaApp.productTour"
export const FETCH_PRODUCT_TOUR_STATE = "FETCH_PRODUCT_TOUR_STATE"
const store = PermanentStore(KEY, {})

export function fetchProductTourState() {
  return function(dispatch) {
    store.get((state)=> {
      if (typeof state == 'boolean') state = {}
      dispatch({ type: FETCH_PRODUCT_TOUR_STATE, state: state })
    })
  }
}

export function hideProductTour(key) {
  return function(dispatch) {
    store.get((state)=> {
      if (typeof state == 'boolean') state = {}
      state[key] = 'hide'
      store.set(state, ()=> {
        dispatch({ type: FETCH_PRODUCT_TOUR_STATE, state: state })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/product-tour.js